import styled from 'styled-components';
import { Button, Text, Box } from '@rsos/components/capstone/base';

export const DataSourceBannerWrapper = styled(Box).attrs({
  horizontal: true,
  position: 'relative',
  align: 'center',
  bg: 'highlights',
  justify: 'space-between',
  px: 20,
  py: 10,
  flow: 10,
})`
  border: ${({ theme }) => `1px solid ${theme.colors.background}`};
  box-shadow: 0 3px 4px ${({ theme }) => theme.colors.lightLineDivider};
  border-radius: 5px;
`;

export const DataSourceTextWrapper = styled(Box).attrs(() => ({
  horizontal: true,
  align: 'center',
}))`
  font-size: 14px;
  overflow: hidden;
`;

export const DataSourceTitleWrapper = styled(Text).attrs(() => ({
  width: '580px',
  horizontal: true,
  display: 'block',
}))`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const ViewDataSourceButton = styled(Button).attrs(() => ({
  btnType: 'primary',
  noMargin: true,
  size: 'small',
}))`
  width: 75px;
`;

export const ButtonWrapper = styled(Box).attrs({
  color: 'secondaryLink',
})`
  margin: auto;
  cursor: pointer;
`;
